class InfiniteScroll extends HTMLElement {
  constructor() {
    super();
    const url = new URL(window.location.href);
    this.loadedPages = [url.searchParams.get('page')];
    this.pageNumber = url.searchParams.get('page');
    this.button = this.querySelector('[data-show-more-products]');
    this.loading = this.querySelector('.loading');
    this.loading.hidden = true;
    if (this.dataset.nextPage) {
      this.loadMoreObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.loadMore();
          }
        });
      });

      this.connectedCallback();
    } else {
      this.hidden = true;
    }

    window.addEventListener('load', () => {
      this.placeholderObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.loadPage(entry.target.dataset.pagePlaceholder);
          }
        });
      });

      document.querySelectorAll('[data-page-placeholder]').forEach((placeholder) => {
        this.placeholderObserver.observe(placeholder);
      });
    })

    this.pageNumberObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (entry.target.dataset.pageNumber === this.pageNumber) {
            return;
          }
          this.pageNumber = entry.target.dataset.pageNumber;
          const url = new URL(window.location.href);
          url.searchParams.set('page', entry.target.dataset.pageNumber);
          history.replaceState({}, '', url);
        }
      });
    });

    document.querySelectorAll('[data-page-number]').forEach((pageNumber) => {
      this.pageNumberObserver.observe(pageNumber);
    });

    this.button.addEventListener('click', (e) => {
      e.preventDefault();
      this.loadMore();
    });
  }

  connectedCallback() {
    this.loadMoreObserver.observe(this);
  }

  disconnectedCallback() {
    this.loadMoreObserver.disconnect();
  }

  loadPage(page) {
    if (this.loadedPages.includes(page)) {
      return;
    }
    this.loadedPages.push(page);
    document.querySelectorAll(`[data-page-placeholder="${page}"]`).forEach((placeholder) => {
      this.placeholderObserver.unobserve(placeholder);
    });

    const url = new URL(window.location.href);
    url.searchParams.set('page', page);
    url.searchParams.set('section_id', this.dataset.sectionId);

    fetch(url)
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const items = [...doc.querySelector('#product-grid').children].filter((item) => !item.classList.contains('grid__item-placeholder'));
        const grid = document.querySelector('#product-grid');
        grid.querySelectorAll(`[data-page-placeholder="${page}"]`).forEach((placeholder, index) => {
          fastdom.mutate(() => {
            placeholder.replaceWith(items[index]);
          });
          this.pageNumberObserver.observe(items[index]);
        });
      });
  }

  loadMore() {
    const url = new URL(this.dataset.nextPage, window.location.origin);
    url.searchParams.set('section_id', this.dataset.sectionId);
    this.loading.hidden = false;
    this.button.hidden = true;

    fetch(url)
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const items = [...doc.querySelector('#product-grid').children].filter((item) => !item.classList.contains('grid__item-placeholder'));
        const grid = document.querySelector('#product-grid');
        fastdom.mutate(() => {
          grid.append(...items);
        });
        items.forEach((item) => {
          this.pageNumberObserver.observe(item);
        });
        const pagination = doc.querySelector('infinite-scroll');
        if (pagination && pagination.dataset.nextPage) {
          this.dataset.nextPage = pagination.dataset.nextPage;
          this.button.hidden = false;
          this.loading.hidden = true;
        } else {
          this.hidden = true;
        }
      });
  }
}

customElements.define('infinite-scroll', InfiniteScroll);